<app-page-body>
  <!-- header -->
  <app-page-header
    *ngIf="!showAddToPublicPlace"
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <section>
        <fieldset>
          <legend>
            {{ "pages.customPlace.form.legend" | translate }}
          </legend>

          <!-- smart sms operators -->
          <app-smart-sms-operators
            *ngIf="isShowMap && !showAddToPublicPlace"
            [isShowToggle]="true"
            [isExistsMCI]="true"
            [isExistsIrancell]="true"
            [isExistsRightel]="true"
            (operators)="operators = $event"
          ></app-smart-sms-operators>

          <div
            class="tw-w-full tw-px-4 tw-py-3"
            [ngClass]="{
              'sm:tw-flex sm:tw-space-x-6 sm:tw-space-x-reverse sm:tw-px-0':
                !customPlaceFormDialog
            }"
          >
            <div
              class="tw-w-full"
              [ngClass]="{
                'sm:tw-w-1/2': !customPlaceFormDialog
              }"
            >
              <div
                class="tw-grid 2xl:tw-grid-cols-2 tw-grid-cols-1 2xl:tw-gap-x-5 tw-w-full"
                [ngClass]="
                  customPlaceFormDialog ? '2xl:tw-gap-y-2' : '2xl:tw-gap-y-4 '
                "
              >
                <!-- title -->
                <form-field
                  [(value)]="model.title"
                  label="common.title"
                  [control]="form?.get('title')"
                >
                </form-field>

                <!-- geometryType -->
                <enum-select-search
                  class="tw-w-full"
                  enumName="GeometryType"
                  [control]="form?.get('geometryType')"
                  label="common.geometryType"
                  [(value)]="model.geometryType"
                  (onError)="onClose()"
                >
                </enum-select-search>

                <!-- state -->
                <zones-select-search
                  label="common.state"
                  class="tw-w-full"
                  [control]="form?.get('province')"
                  [id]="1"
                  [value]="selectedState"
                  (valueChange)="onChangeZones($event)"
                  (onError)="onClose()"
                >
                </zones-select-search>

                <!--city(zoneId) -->
                <zones-select-search
                  label="common.city"
                  class="tw-w-full"
                  [control]="form?.get('city')"
                  [id]="model.provinceId"
                  [value]="model.cityId"
                  (valueChange)="model.cityId = $event; onCityChange($event)"
                  (onError)="onClose()"
                >
                </zones-select-search>

                <!-- isActive -->
                <div class="2xl:tw-col-span-2 tw-mb-3">
                  <mat-slide-toggle
                    formControlName="isActive"
                    [(ngModel)]="model.isActive"
                  >
                    {{ "common.isActive" | translate }}</mat-slide-toggle
                  >
                </div>
              </div>
            </div>

            <!--manual and reverse polygon-->
            <div
              *ngIf="isShowManualPolygon"
              class="tw-w-full"
              [ngClass]="{
                'sm:tw-w-1/2': !customPlaceFormDialog
              }"
            >
              <div class="tw-w-full">
                <app-manual-polygon
                  customClass="tw-w-full"
                  [pageVocabs]="pageVocabs"
                  [isShowMap]="isShowMap"
                  [form]="form"
                  (finalPolygon)="polygon = $event"
                ></app-manual-polygon>
              </div>
            </div>
          </div>

          <div *ngIf="isShowMap && !showAddToPublicPlace" class="row">
            <div class="tw-w-full">
              <smart-send-map-control
                *ngIf="isShowMap"
                #Map
                (OnHelp)="showMapHelp($event)"
                (OnLoad)="onMapReady()"
                [Theme]="appStateService.currentThemeMode()"
                [ShowSaveButton]="false"
                [MultiPolygon]="true"
                [manualPolygon]="polygon"
                [operators]="operators"
                [model]="model"
              ></smart-send-map-control>
            </div>
          </div>

          <div
            class="tw-flex-center role-public-place-loading"
            *ngIf="!isShowMap"
          >
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <span class="text-primary tw-text-lg tw-font-medium tw-mx-2">{{
              "common.loading" | translate
            }}</span>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onSubmit)="onSubmit()"
        (onClose)="!showAddToPublicPlace ? onClose() : emitClose()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
